import { isImpersonationTab } from './impersonationSession';

// an impersonation tab keeps its tokens in sessionStorage only, so the localStorage session of a consumer signed in
// on the same browser is never read, overwritten or cleared from that tab
const tokenStorage = () => (isImpersonationTab() ? sessionStorage : localStorage);

export const getToken = tokenName => {
    const token = tokenStorage().getItem(tokenName);

    if (token === null || token === 'undefined') {
        return null;
    }

    return JSON.parse(token);
};

export const updateToken = (tokenName, token) => {
    tokenStorage().setItem(tokenName, JSON.stringify(token));
};

export const removeToken = tokenName => {
    tokenStorage().removeItem(tokenName);
};
